import styled from 'styled-components';
import {BackgroundImage} from '../../components/Common/BackgroundImage/BackgroundImage';

export const StyledBackgroundImage = styled(BackgroundImage)`
    filter: brightness(0.4);
`;
